import clsx from 'clsx';
import { ComponentProps, FC, ReactNode, CSSProperties } from 'react';

import { AnimatedArrowPair } from '../AnimatedArrowPair';
import { Flex } from '../Flex';
import { Text } from '../Text';

import styles from './Box.module.scss';


type BoxProps = ComponentProps<'div'> & {
  iconIn?: ReactNode;
  iconOut?: ReactNode;
  icon?: ReactNode;
  iconSize?: string;
  title: string;
  description: string;
};

export const Box: FC<BoxProps> = (props) => {
  const { className, iconIn, iconOut, icon, iconSize, title, description, children, ...rest } = props;

  return (
    <div className={clsx(styles.root, className)} {...rest}>
      <div className={styles.content}>
        {iconIn && iconOut && (
          <div className={styles.animatedIconWrapper} style={{ '--icon-size': iconSize } as CSSProperties}>
            <AnimatedArrowPair iconIn={iconIn} iconOut={iconOut} />
          </div>
        )}

        {icon && (
          <div className={styles.iconWrapper} style={{ '--icon-size': iconSize } as CSSProperties}>
            {icon}
          </div>
        )}

        {children}

        <Flex direction={'column'} gap={2} className={styles.textWrapper}>
          <Text type={'h3'}>{title}</Text>

          <Text type={'body16'} color={'white50'} className={styles.description}>
            {description}
          </Text>
        </Flex>
      </div>
    </div>
  );
};